var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useContext, useEffect, useState } from "react";
import { PDFGenContext } from "../../../../misc/pdf/PDFGenerator";
import { api } from "../../../../api/API";
import { sleep } from "nate-react-api-helpers";
export function usePrintParallel() { const { isPrinting, isPrintingRef, print } = useContext(PDFGenContext); const [queue, setQueue] = useState([]); const [errors, setErrors] = useState([]); const [loadingCount, setLoadingCount] = useState(0); const [totalCount, setTotalCount] = useState(0); useEffect(() => { if (isPrinting)
    return; if (isPrintingRef.current)
    return; const item = queue.shift(); if (!item)
    return; (() => __awaiter(this, void 0, void 0, function* () { setLoadingCount(old => old + 1); setTotalCount(old => old + 1); const done = () => { setLoadingCount(old => old - 1); }; try {
    console.log("print: call()");
    const content = yield print(item.render, makeConfigurator(item.serverInfo, v => { item.serverInfo = v; }));
    const info = yield api.print.print({ content: content, name: item.name, args: item.serverInfo ? JSON.stringify(item.serverInfo) : "" });
    while (true) {
        yield sleep(1000);
        const status = yield api.print.getStatus({ uuid: info.uuid });
        if (status.failed) {
            setErrors(old => [...old, "PDF failed: " + item.name]);
            done();
            return;
        }
        else if (status.ready) {
            if (item.download) {
                api.print.download({ uuid: info.uuid });
            }
            if (item.onComplete) {
                item.onComplete({ print: info.uuid, submission: status.submission, file: status.file });
            }
            done();
            return;
        }
    }
}
catch (e) {
    setErrors(old => [...old, e.toString()]);
    done();
    if (item.onError) {
        item.onError(e);
    }
} }))(); }, [isPrinting, queue, loadingCount, print, isPrintingRef]); return { printer: useCallback(input => { setQueue(old => [...old, input]); }, []), reset: useCallback(() => { setTotalCount(0); setErrors([]); setLoadingCount(0); }, []), loading: loadingCount > 0, errors: errors, loadingCount: loadingCount, totalCount: totalCount }; }
export function makeConfigurator(cfg, onChange) { let base = cfg; return { adjust(cb) { base = cb(base); onChange(base); } }; }
